import { render, staticRenderFns } from "./msgOption.vue?vue&type=template&id=2b5042a8&scoped=true"
import script from "./msgOption.vue?vue&type=script&lang=js"
export * from "./msgOption.vue?vue&type=script&lang=js"
import style0 from "./msgOption.vue?vue&type=style&index=0&id=2b5042a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5042a8",
  null
  
)

export default component.exports